import { ThreeDotsVertical } from "react-bootstrap-icons";

//App
import Button from "../VFX-UI/Button/Button";
import useButtonStyles from "./styles";
import React from "react";

const MoreActionButton = ({
  handleActionClick,
}: {
  handleActionClick: React.MouseEventHandler<HTMLButtonElement>;
}) => {
  const buttonsStyles = useButtonStyles();
  return (
    <Button style={buttonsStyles.noBackgroundColor} onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleActionClick(e)} >
          <ThreeDotsVertical style={buttonsStyles.actionDots} />
    </Button>
  );
};

export default MoreActionButton;
